import { node, shape } from 'prop-types';
import React, { createContext, PureComponent } from 'react';

import { ENV } from '../reactor/common';

const { IS_WEB } = ENV;
const Context = createContext();
const { Provider, Consumer: ConsumerData } = Context;

class ProviderData extends PureComponent {
  static propTypes = {
    children: node,
    store: shape({}),
  };

  static defaultProps = {
    children: undefined,
    store: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      dataSource: props.store,
    };
  }

  onDataSource = (dataSource = {}) => {
    if (IS_WEB && dataSource.title) document.title = dataSource.title;

    this.setState({
      dataSource,
      // dataSource: require('./mocks/story.json'),
    });
  }

  render() {
    const { onDataSource, props: { children }, state } = this;

    return (
      <Provider value={{ ...state, onDataSource }}>
        { children }
      </Provider>
    );
  }
}

export { ConsumerData, ProviderData };
